import "./fonts/arabic.css";

export const lightColors = {
  primary: "#2c7be5",
  secondary: "#748194",
  success: "#00d27a",
  info: "#27bcfd",
  warning: "#f5803e",
  danger: "#e63757",
  background: "#f9fafd",
  text: "#5e6e82",
  border: "#fff",
  skeleton: "#eee",
  skeletonHighlight: "#f5f5f5",
};

export const darkColors = {
  primary: "#2c7be5",
  secondary: "#748194",
  success: "#00d27a",
  info: "#27bcfd",
  warning: "#f5803e",
  danger: "#e63757",
  background: "#0b1727",
  text: "#f9fafd",
  border: "#0E1C2F",
  skeleton: "#132238",
  skeletonHighlight: "#16263f",
};

export const lightGrays = {
  white: "#fff",
  100: "#f9fafd",
  200: "#edf2f9",
  300: "#d8e2ef",
  400: "#b6c1d2",
  500: "#9da9bb",
  600: "#748194",
  700: "#5e6e82",
  800: "#4d5969",
  900: "#344050",
  1000: "#232e3c",
  1100: "#0b1727",
  black: "#000",
};

export const darkGrays = {
  white: "#fff",
  1100: "#f9fafd",
  1000: "#edf2f9",
  900: "#d8e2ef",
  800: "#b6c1d2",
  700: "#9da9bb",
  600: "#748194",
  500: "#5e6e82",
  400: "#4d5969",
  300: "#344050",
  200: "#232e3c",
  100: "#0b1727",
  black: "#000",
};

export const mediaQueries = {
  xs: null,
  sm: null,
  md: "(max-width: 768px)",
  lg: null,
  xl: null,
};
